import {
  Box,
  Button,
  ButtonGroup,
  Dialog,
  IconButton,
  InputLabel,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, useContext, useState } from "react";
import { IoIosClose } from "react-icons/io";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { AiFillSave } from "react-icons/ai";
import ListModulesPermissions from "../ListModulesPermissions";
import RolePermissionsService from "../../../../../services/rolesPermissions.service";
import { AuthContext } from "../../../../../contexts/auth";
import { FaCheck } from "react-icons/fa";
import { TabPanel } from "../../../../TabPanel";

type Props = {
  role?: any;
  onClose: () => void;
  onSuccess?: (roleData: any) => void;
};

interface ArrayActive {
  title: string;
  type: string;
  status: boolean;
}

const RoleModal: React.FC<Props> = (props) => {
  const { actionOptions } = useContext(AuthContext);
  const { onClose, onSuccess, role } = props;
  const [optsState, setOpts] = useState<any>([]);
  const [tabActive, setTabActive] = React.useState(0);

  const [active, setActive] = useState<Array<ArrayActive>>([]);

  const { mutate: createRole, isLoading: isLoadingCreate } = useMutation(
    RolePermissionsService.create,
    {
      onSuccess: () => {
        toast.success("Função criada com sucesso!");
        onSuccess && onSuccess(roleData);
      },
      onError: (error) => {
        toast.error("Não foi possível criar a função");
      },
    }
  );

  const { mutate: updateRole, isLoading: isLoadingUpdate } = useMutation(
    (data: any) => RolePermissionsService.update(role._id, data),
    {
      onSuccess: () => {
        toast.success("Função atualizada com sucesso!");
        onSuccess && onSuccess(initialRoleData);
      },
      onError: (error) => {
        toast.error("Não foi possível atualizar a função");
      },
    }
  );

  const [initialRoleData, setInitialRoleData] = React.useState(role);

  const [roleData, setRoleData] = React.useState({
    name: initialRoleData?.name || "",
    description: initialRoleData?.description || "",
    active: initialRoleData?.active || true,
    modules: initialRoleData?.modules || [],
  });

  function handleChange(
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const { name, value } = e.target;

    setRoleData({ ...roleData, [name]: value });
  }

  const handleSubmmit = (e: React.MouseEvent) => {
    e.preventDefault();
    let updatedRoleData = { ...roleData };
    if (optsState.length > 0) {
      updatedRoleData.modules = [...optsState];
    }
    role ? updateRole(updatedRoleData) : createRole(updatedRoleData);
    const { name } = e.target as HTMLButtonElement;
    if (name === "save-close") onClose();
  };
  const isDisabled =
    isLoadingCreate ||
    isLoadingUpdate ||
    (!actionOptions["createControle de acesso"] &&
      !actionOptions["updateControle de acesso"]);
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <Box p={4}>
        <Box display={"flex"} alignItems={"center"} mb={3} gap={2}>
          <Typography variant="h5">
            {!role ? "Nova função" : "Função"}
          </Typography>

          <ButtonGroup
            disableElevation
            variant="outlined"
            aria-label="Change status"
            size="small"
          >
            <Button
              onClick={() => setRoleData({ ...roleData, active: true })}
              sx={{
                textTransform: "none",
                color: roleData.active ? "white" : "#222222",
                fontWeight: roleData.active ? 700 : 400,
                backgroundColor: roleData.active ? "#1976D2" : "white",
                "&:hover": {
                  backgroundColor: roleData.active ? "#176dc4" : "#f5f5f5",
                },
              }}
              startIcon={roleData.active && <FaCheck size={12} />}
            >
              Ativo
            </Button>

            <Button
              onClick={() => setRoleData({ ...roleData, active: false })}
              sx={{
                textTransform: "none",
                color: !roleData.active ? "white" : "#222222",
                fontWeight: !roleData.active ? 700 : 400,
                backgroundColor: !roleData.active ? "#1976D2" : "white",
                "&:hover": {
                  backgroundColor: !roleData.active ? "#176dc4" : "#f5f5f5",
                },
              }}
              startIcon={!roleData.active && <FaCheck size={12} />}
            >
              Inativo
            </Button>
          </ButtonGroup>
        </Box>

        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <IoIosClose width={32} height={32} color="#222222" size={32} />
          </IconButton>
        ) : null}

        <Tabs
          value={tabActive}
          onChange={(e, index) => {
            setTabActive(index);
          }}
          indicatorColor="primary"
          aria-label="full width tabs example"
          style={{ borderBottom: "1px solid #E0E0E0" }}
        >
          <Tab label="Informações" sx={{ textTransform: "none" }} />
          <Tab
            label="Permissões"
            sx={{ textTransform: "none", color: "#666666" }}
          />
          <Tab
            label="Usuários vinculados à função"
            sx={{ textTransform: "none", color: "#666666" }}
          />
        </Tabs>

        <TabPanel value={tabActive} index={0}>
          <Box
            component="form"
            // sx={{ "& .MuiTextField-root": { m: 1 } }}
            autoComplete="off"
            width={"100%"}
          >
            <span style={{ fontSize: 16, fontWeight: 600 }}>Informações</span>

            <div style={{ marginTop: 16 }}>
              <span style={{ fontSize: 14, fontWeight: 400 }}>
                Nome da função
              </span>
              <TextField
                fullWidth
                size="small"
                name="name"
                value={roleData.name}
                onChange={handleChange}
                placeholder="Nome função"
                sx={{ mb: 2 }}
              />

              <span style={{ fontSize: 14, fontWeight: 400 }}>Descrição</span>
              <TextField
                fullWidth
                size="small"
                name="description"
                value={roleData.description}
                onChange={handleChange}
                multiline
                placeholder="Descrição"
              />
            </div>
          </Box>
        </TabPanel>

        <TabPanel value={tabActive} index={1}>
          <ListModulesPermissions
            optsState={optsState}
            setOpts={setOpts}
            setActive={setActive}
            active={active}
            modules={roleData.modules}
          />
        </TabPanel>

        <TabPanel value={tabActive} index={2}>
          <Box>
            <Typography variant="subtitle1" mb={2}>
              Usuários vinculados à função
            </Typography>
            {role?.users && role.users.length > 0 ? (
              <Box
                sx={{
                  maxHeight: 250,
                  overflowY: "auto",
                  border: "1px solid #eee",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                {role.users.map((user: any) => (
                  <Box key={user._id} mb={1}>
                    <Typography variant="body1" fontWeight={500}>
                      {user.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {user.email}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Nenhum usuário atribuído a esta função atualmente.
              </Typography>
            )}
          </Box>
        </TabPanel>

        <Box display={"flex"} justifyContent={"flex-end"} gap={2} mt={4}>
          <Button
            variant="outlined"
            onClick={onClose}
            style={{ textTransform: "none" }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmmit}
            disabled={isDisabled}
            style={{ textTransform: "none" }}
            name="save-close"
          >
            Salvar e Fechar
          </Button>
          {/* <Button
            variant="contained"
            onClick={handleSubmmit}
            disabled={isDisabled}
            style={{ textTransform: "none" }}
            name="save"
          >
            <AiFillSave size={22} />
          </Button> */}
        </Box>
      </Box>
    </Dialog>
  );
};

export default RoleModal;
